import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "../slices/loginSlice.js"
import userSlice from "../slices/userSlice.js"
import formReducer from "../slices/formSlice.js";  
import { persistStore,persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  login: loginSlice,
  user: userSlice,
  form: formReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["form"], // sirf form save hoga
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});
export const persistor = persistStore(store);